import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'aw-text-area',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    ToFormControlPipe,
    AppendTestIdPipe,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './text-area.component.html',
})
export class TextAreaComponent extends FormInputComponent {
  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }
}
